import { useUserActivity } from '@plug-core/state'
import {
  hasVault,
  isInitialized,
  isPasswordSet,
  isVaultUnlocked,
  keychainManager,
} from '@plug-core/keyring'

import type { Messenger } from '@plug-core/interfaces/messenger'

const LOCK_TIMEOUT = 60 * 60

export const subscribeToWalletState = async (messengers: Messenger[]) => {
  keychainManager.subscribe(async () => {
    const isReady = isInitialized()
    const _hasVault = isReady && (await hasVault())
    const unlocked = _hasVault && isVaultUnlocked()
    const hasPassword = _hasVault && (await isPasswordSet())

    const state = {
      isReady,
      hasVault: _hasVault,
      unlocked,
      hasPassword,
    }

    messengers.forEach((messenger) => messenger.send('wallet-state-changed', state))
  })
}

export const setLockInterval = () => {
  setInterval(async () => {
    const { lastUserActivityAt } = useUserActivity.getState()

    if (!lastUserActivityAt || !isVaultUnlocked()) return

    if (new Date().getTime() - Date.parse(lastUserActivityAt) > LOCK_TIMEOUT * 1000) {
      keychainManager.lock()
    }
  }, 1000)
}
